import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-it-works-ai',
  templateUrl: './how-it-works-ai.component.html',
  styleUrls: ['./how-it-works-ai.component.scss']
})
export class HowItWorksAIComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
